import React, { useCallback, useEffect, useMemo, useState } from "react";
import { GraphDisplayType } from "../../models/SharedModel";
import Plot from "react-plotly.js";
import { Data } from "plotly.js";

interface IGraphComponentProps {
  graphData: any;
  displayType: GraphDisplayType;
}

const GraphComponent = (props: IGraphComponentProps) => {
  const { graphData, displayType } = props;

  // states
  const [selectedPlot, setSelectedPlot] = useState<any>(null);

  const displayPlotsList = () => {
    return graphData?.map((each: any) => (
      <div
        className={`plots-item ${each?.plotId === selectedPlot?.plotId ? 'selected' : 'default'}`}
        key={each?.plotId}
        onClick={() => setSelectedPlot(each)}
      >
        <Plot
          data={each?.data as Data[]}
          layout={{
            legend: {
              itemwidth: 0,
            },
            showlegend: false,
            title: "",
            height: 285,
            width: 285,
            hovermode: false,
            autosize: false,
            xaxis: {
              visible: false,
              showgrid: false,
              zeroline: false,
            },
            xaxis2: {
              visible: false,
              showgrid: false,
              zeroline: false,
            },
            xaxis3: {
              visible: false,
              showgrid: false,
              zeroline: false,
            },
            yaxis: {
              visible: false,
              showgrid: false,
              zeroline: false,
            },
            yaxis2: {
              visible: false,
              showgrid: false,
              zeroline: false,
            },
            yaxis3: {
              visible: false,
              showgrid: false,
              zeroline: false,
            },
            margin: {
              l: 10,
              r: 10,
              b: 10,
              t: 10,
            },
          }}
          useResizeHandler={true}
          config={{
            displayModeBar: false,
            autosizable: false,
          }}
        />
      </div>
    ));
  };

  const displayPlots = useCallback(
    () => (
      <>
        <div className="plots-inner">
          { displayType === GraphDisplayType.ALL ? <></> : 
            <div className="selected-plot">
              <Plot
                data={selectedPlot?.data as Data[]}
                layout={{
                  ...(selectedPlot?.layout ? selectedPlot?.layout : {}),
                  autosizable: false,
                  width: 1000,
                }}
                useResizeHandler={true}
                config={{
                  autosizable: false,
                }}
              />
            </div>
          }
          {displayType === GraphDisplayType.SINGLE ? (
            <></>
          ) : (
            <div className="plots-list">{displayPlotsList()}</div>
          )}
        </div>
      </>
    ),
    [selectedPlot]
  );

  // useEffect
  useEffect(() => {
    setSelectedPlot(graphData?.[0]);
  }, []);

  return <div>{displayPlots()}</div>;
};

export default GraphComponent;
